import React from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import Layout from "../../components/layout";
import AdminQuizzCategories from "../../components/adminQuizzCategories";
import { getClassificationByLevel } from "../../actions/products";
import {
  getAccountingAccounts,
  getCatalogAccrual
} from "../../actions/catalogs";

interface Props {
  getClassificationByLevel: (level: number) => any;
  getAccountingAccounts: () => any;
  getCatalogAccrual: () => any;
  catalogAccrual: any;
  accountingAccounts: any;
}

class AdminQuizzCategoriesPage extends React.Component<Props> {
  render() {
    return (
      <main>
        <Helmet title="Sports Products" />
        <Layout>
          <AdminQuizzCategories />
        </Layout>
      </main>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getClassificationByLevel: (level: number) => {
    return dispatch(getClassificationByLevel(level));
  },
  getAccountingAccounts: () => {
    return dispatch(getAccountingAccounts());
  },
  getCatalogAccrual: () => {
    return dispatch(getCatalogAccrual());
  }
});

const mapStateToProps = state => {
  const { catalogs } = state;
  return {
    catalogAccrual: catalogs.catalogAccrual,
    accountingAccounts: catalogs.accountingAccounts
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminQuizzCategoriesPage);
